import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

export default function CTASection() {
  const { t } = useLanguage();

  const scrollToAppointment = () => {
    const el = document.querySelector('#appointment');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="py-20 md:py-28 bg-[#0F172A] relative overflow-hidden" data-testid="cta-section">
      {/* Decorative elements */}
      <div className="absolute top-0 left-0 w-80 h-80 bg-[#D1A760]/5 rounded-full -translate-x-1/2 -translate-y-1/2 blur-3xl" />
      <div className="absolute bottom-0 right-0 w-[500px] h-[500px] bg-[#D1A760]/5 rounded-full translate-x-1/3 translate-y-1/3 blur-3xl" />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] border border-[#D1A760]/5 rounded-full" />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[400px] h-[400px] border border-[#D1A760]/5 rounded-full" />
      
      <div className="relative z-10 max-w-3xl mx-auto px-6 md:px-12 text-center">
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#D1A760]/10 border border-[#D1A760]/20 mb-8">
          <div className="w-2 h-2 rounded-full bg-[#D1A760] animate-pulse" />
          <span className="text-xs font-manrope text-[#D1A760]">Limited slots available this week</span>
        </div>
        <h2 className="font-outfit font-light text-3xl sm:text-4xl lg:text-5xl text-white tracking-tight" data-testid="cta-title">
          {t('cta_title')}
        </h2>
        <p className="mt-6 text-base text-white/50 font-manrope max-w-xl mx-auto leading-relaxed">
          {t('cta_subtitle')}
        </p>
        <button
          onClick={scrollToAppointment}
          className="mt-10 px-10 py-4 rounded-full bg-gradient-to-r from-[#D1A760] to-[#B89255] text-white font-manrope font-semibold text-sm hover:shadow-[0_4px_30px_rgba(209,167,96,0.4)] transition-all duration-300 animate-pulse-gold"
          data-testid="cta-book-btn"
        >
          {t('cta_button')}
        </button>
        <p className="mt-4 text-xs text-white/30 font-manrope">Mon-Sat: 11:00 AM - 5:30 PM | Sunday Closed</p>
      </div>
    </section>
  );
}
